import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TagPreviewUnit } from '../../model/tag-preview-unit';

@Component({
  selector: 'app-tag-preview-dialog',
  templateUrl: './tag-preview-dialog.component.html',
  styleUrls: ['./tag-preview-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatButton, MatIcon]
})
export class TagPreviewDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<TagPreviewDialogComponent>>(MatDialogRef);
  private readonly data = inject<TagPreviewUnit[]>(MAT_DIALOG_DATA);
  units: TagPreviewUnit[] = this.data || [];
  index = 0;
  lineJump!: string;

  getCurrentUnit(): TagPreviewUnit {
    return this.units[this.index];
  }

  hasShippingTag(): boolean {
    const unit = this.getCurrentUnit();
    return !!unit && (this.isNotBlank(unit.reference) || this.isNotBlank(unit.location));
  }

  hasRiserTag(): boolean {
    const unit = this.getCurrentUnit();
    return !!unit && (/SM|SG/.test(unit.partNumber || '') || /SM|SG/.test(unit.lineDescription || ''));
  }

  private isNotBlank(value: string): boolean {
    return (value || '').trim().length > 0;
  }

  move(step: number): void {
    const next = this.index + step;
    if (next >= 0 && next < this.units.length) {
      this.index = next;
    }
  }

  jumpToLine(): void {
    const target = this.units.findIndex(unit => unit.lineId === this.lineJump);
    if (target >= 0) {
      this.index = target;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
